import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";
import type { SnackbarSlice } from "./types/snackbar";

const initialState: SnackbarSlice = {
  open: false,
  message: "",
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    openSnackbar: (state, action: PayloadAction<Pick<SnackbarSlice, "message" | "description" | "intent">>) => {
      return {
        ...state,
        open: true,
        message: action.payload.message,
        description: action.payload.description,
        intent: action.payload.intent,
      };
    },
    closeSnackbar: () => {
      return initialState;
    },
  },
});

export const { openSnackbar, closeSnackbar } = snackbarSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const snackbarSelector = (state: RootState) => {
  return state.snackbar;
};

export default snackbarSlice.reducer;
